module.exports = __webpack_public_path__ + "img/monk-and-bela.bf8a1e2d.svg";